import Error from '../model/Error';
import axios from 'axios';

export default class AiAssistantRepository {
    static findByClub(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/${clubId}/ai-assistant/department-images`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static findDepartmentImage(clubId, hash) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/${clubId}/ai-assistant/department-images/${hash}.jpg`, { responseType: 'arraybuffer' })
                .then((response) => resolve({
                    status: response.status,
                    url: URL.createObjectURL(new Blob([response.data], { type: 'image/jpg' })),
                }))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static create(clubId, hash, departmentId, additionalInfo) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/club/${clubId}/ai-assistant/department-images`, { departmentId, hash, additionalInfo })
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static use(clubId, hash) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/${clubId}/ai-assistant/department-images/${hash}.jpg`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static delete(clubId, hash) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/${clubId}/ai-assistant/department-images/${hash}.jpg`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
